var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHercules(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 12,
    viewBox: "0 0 18 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.3125 1.25C3.3125 0.818359 3.66797 0.4375 4.125 0.4375H4.9375C5.36914 0.4375 5.75 0.818359 5.75 1.25V5.3125V6.9375V11C5.75 11.457 5.36914 11.8125 4.9375 11.8125H4.125C3.66797 11.8125 3.3125 11.457 3.3125 11V9.375H2.5C2.04297 9.375 1.6875 9.01953 1.6875 8.5625V6.9375C1.23047 6.9375 0.875 6.58203 0.875 6.125C0.875 5.69336 1.23047 5.3125 1.6875 5.3125V3.6875C1.6875 3.25586 2.04297 2.875 2.5 2.875H3.3125V1.25ZM14.6875 1.25V2.875H15.5C15.9316 2.875 16.3125 3.25586 16.3125 3.6875V5.3125C16.7441 5.3125 17.125 5.69336 17.125 6.125C17.125 6.58203 16.7441 6.9375 16.3125 6.9375V8.5625C16.3125 9.01953 15.9316 9.375 15.5 9.375H14.6875V11C14.6875 11.457 14.3066 11.8125 13.875 11.8125H13.0625C12.6055 11.8125 12.25 11.457 12.25 11V6.9375V5.3125V1.25C12.25 0.818359 12.6055 0.4375 13.0625 0.4375H13.875C14.3066 0.4375 14.6875 0.818359 14.6875 1.25ZM11.4375 5.3125V6.9375H6.5625V5.3125H11.4375Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHercules);
export default ForwardRef;